import { Button, Flex, Form, Input, Modal, notification, Switch } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { editCareer, ICareerEdit } from '../../../api/customerCareer/customerCareerApi'
import { useForm } from 'antd/es/form/Form'

interface Props {
  show: boolean
  infoCustomerCareer?: ICareerEdit
  modalClose?: () => void
  onSubmitModalEdit: (isSucces: boolean, errorMessage?: string) => void
}

const EditCareerModal: React.FC<Props> = (props) => {
  const { show, infoCustomerCareer, modalClose, onSubmitModalEdit } = props
  const [isStatus, setIsStatus] = useState(false)
  const formRef: any = useRef(null)
  const [form] = useForm()

  const onFormFinish = async (value: any) => {
    const { code, name } = value
    const result = await editCareer(Number(infoCustomerCareer?.id), code, name, Number(isStatus))
    if (result.status) {
      onSubmitModalEdit?.(true)
    } else {
      onSubmitModalEdit?.(false, result.message)
    }
  }

  useEffect(() => {
    if (show && infoCustomerCareer) {
      form.setFieldValue('name', infoCustomerCareer?.title)
      form.setFieldValue('code', infoCustomerCareer?.code)

      setIsStatus(!!infoCustomerCareer?.status)
    } else {
      setIsStatus(false)
    }
  }, [show, infoCustomerCareer])



  return (
    <>
      <Modal
        open={show}
        title='Chỉnh sửa nghề nghiệp'
        className='rs-modal w-400 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form
          form={form}
          ref={formRef}
          className='rs-form add-relative-form'
          onFinish={onFormFinish}
          requiredMark={false}
        >
          <Form.Item
            layout='vertical'
            label='Mã nghề nghiệp'
            
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập Mã nghề nghiệp" }
            ]}
          >
            <Input
              placeholder='Mã nghề nghiệp'
              maxLength={8}
              className='rs-input rs-input--32'
            />
          </Form.Item>
          <Form.Item
            layout='vertical'
            label='Tên nghề nghiệp'
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập Tên nghề nghiệp" }
            ]}
          >
            <Input
              placeholder='Tên nghề nghiệp'
              className='rs-input rs-input--32'
            />
          </Form.Item>

          <Form.Item name='status'>
            <Flex className='gap-24px'>
              <span>Sử dụng</span>
              <Switch
                checked={isStatus}
                onChange={() => setIsStatus(!isStatus)}
                className="rs-switch"
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default EditCareerModal
